import { Link } from 'gatsby-plugin-react-intl'
import styled from 'styled-components'
import arrow from '../../images/icons/arrow-right.svg'
import arrowExternalIcon from '../../images/icons/external-link.svg'



export const FooterWrapper = styled.footer`
  background-color: var(--black);
  padding: 80px 48px 92px;

  h4 {
    font-family: Inter;
    margin-bottom: 24px;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    font-size: 12.6px;
    font-weight: 700;
  }

  ul li,
  span,
  p {
    font-size: 14px;
    line-height: 24.5px;
  }

  @media (max-width: 768px) {
    padding: 48px 24px;
  }
`

export const Container = styled.section`
  max-width: 1248px;
  margin: 0 auto;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 56px;
  margin-bottom: 24px;
  color: #bbb;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const UseCases = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const ColUseCases = styled.div`
  width: 100%;
  max-width: 368px;

  &:nth-of-type(3) {
    max-width: 290px;
  }
`

export const UseCasesList = styled.div`
  margin-bottom: 48px;
  margin-right: 32px;
`

export const UseCaseItem = styled.li`
  margin-bottom: 16px;
`

export const InternalLink = styled(Link)`
  font-size: 14px;
  line-height: 1.75;
  color: #bbbbbb;
  text-decoration: none;
  transition: color 0.2s;
  padding: 5px;
  margin-left: -5px;

  position: relative;

  span {
    background-color: var(--orange);
    color: #fff;
    text-transform: uppercase;
    border-radius: 4px;
    padding: 2px 4px;
    margin-left: 8px;
    font-size: 12px;
    font-weight: 700;
  }

  ::after {
    content: url(${arrow});
    position: absolute;
    top: 6px;
    margin-left: 4px;
    opacity: 0;
    transition: opacity 0.2s;
  }

  :hover {
    color: var(--orange);

    ::after {
      opacity: 1;
    }
  }
`

export const ExternalLink = styled(InternalLink)`
  ::after {
    content: url(${arrowExternalIcon});
    top: 3px;
    margin-left: 7px;
  }
`

export const Menu = styled.div`
  width: 100%;
  max-width: 208px;

  li {
    margin-bottom: 24px;
  }

  @media (max-width: 768px) {
    min-width: 100%;
    padding-top: 32px;
    margin-bottom: 24px;
    border-top: 1px solid #444;
  }
`

export const CopyRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #999;

  margin-top: 48px;
  padding-top: 32px;
  border-top: 1px solid #444;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const Copy = styled.p`
    margin-right: 32px;

  @media (max-width: 768px) {
    margin-bottom: 32px;
    margin-right: 0;
  }
`
